// extracted by mini-css-extract-plugin
module.exports = {"button":"ModaleDetail_button__3_pEg","container":"ModaleDetail_container__c12tA","modalBody":"ModaleDetail_modalBody__nypRM"};